import React, { Component } from 'react';
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { styled } from "@material-ui/styles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { isEmpty } from "lodash";
import classNames from "classnames";
import Tooltip from '@material-ui/core/Tooltip';
import { connect } from 'react-redux';
import {
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableFooter,
    TableSortLabel,
    TableContainer,
    TextField,
    Box,
    Stepper,
    Step,
    StepLabel,
    Checkbox,
    FormControlLabel,
    List,
    ListItem,
    Icon
} from "@material-ui/core";


import {
    warningColor,
    primaryColor,
    dangerColor,
    successColor,
    infoColor,
    roseColor,
    grayColor,
    defaultFont,
} from "../../../../../../assets/jss/material-kit-pro-react.js";
import { whiteColor } from "../../../../../../assets/jss/material-kit-pro-react.js";
import history from '../../../../../../history';
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";
import { formatNumberWithDecimals, formatCurrency } from '../../../../../utils/formatNumber.js';

const useStyles = theme => ({
    warning: {
        color: warningColor[0],
    },
    primary: {
        color: primaryColor[0],
    },
    danger: {
        color: dangerColor[0],
    },
    success: {
        color: successColor[0],
    },
    info: {
        color: infoColor[0],
    },
    rose: {
        color: roseColor[0],
    },
    gray: {
        color: grayColor[0],
    },
    right: {
        textAlign: "right",
    },
    table: {
        padding: "10px",
        marginBottom: "0",
        width: "100%",
        maxWidth: "100%",
        backgroundColor: "transparent",
        borderSpacing: "0",
        borderCollapse: "collapse",
        overflow: "auto",
        "& > tbody > tr, & > thead > tr": {
            height: "auto",
        },
        //"& th":

        //    { textAlign: "left", background: "#eee", position: "sticky", top: "0px" }


    },
    tableShoppingHead: {
        fontSize: "0.75em !important",
        textTransform: "uppercase !important",
    },
    tableCell: {
        ...defaultFont,
        lineHeight: "1.5em",
        padding: "12px 8px!important",
        verticalAlign: "middle",
        fontSize: "0.999rem",
        borderBottom: "none",
        borderTop: "2px solid " + grayColor[6],
        position: "relative",
        color: grayColor[1],
        borderWidth: 0, borderWidth: 1, borderColor: grayColor[6], borderStyle: 'solid',
        width: "auto",
    },
    tableHeadCell: {
        fontSize: "1.17rem",
        borderBottomWidth: "2px",
        fontWeight: "250",
        color: whiteColor,
        borderTopWidth: "0 !important",
        backgroundColor: infoColor[0],
        //width: "14.2%",
        //height: "100%"

    },
    tableCellTotal: {
        fontWeight: "500",
        fontSize: "1.0625rem",
        paddingTop: "20px",
        textAlign: "right",
    },
    tableCellAmount: {
        fontSize: "26px",
        fontWeight: "300",
        marginTop: "5px",
        textAlign: "right",
    },
    tableResponsive: {
        minHeight: "0.1%",
        overflowX: "auto",
        /*        padding: "2px"*/
    },
    tableStripedRow: {
        backgroundColor: grayColor[16],
    },
    tableRowHover: {
        "&:hover": {
            backgroundColor: grayColor[23],
        },
    },
    warningRow: {
        backgroundColor: warningColor[4],
        "&:hover": {
            backgroundColor: warningColor[5],
        },
    },
    dangerRow: {
        backgroundColor: dangerColor[4],
        "&:hover": {
            backgroundColor: dangerColor[5],
        },
    },
    successRow: {
        backgroundColor: successColor[4],
        "&:hover": {
            backgroundColor: successColor[5],
        },
    },
    infoRow: {
        backgroundColor: infoColor[4],
        "&:hover": {
            backgroundColor: infoColor[5],
        },
    },
    tableRightBorder: { borderWidth: 0, borderWidth: 1, borderColor: 'red', borderStyle: 'solid' } // or borderTop: '1px solid red'



});



class OrderSelectedProductList extends Component {


    componentDidMount() {
        //redirect user if they don't have the valid details

        if (!isEmpty(this.props.orderSelectedProductsList)) {

        }
        else {
       /*     history.push('/OrderForm');*/
            this.props.history.push("/OrderForm");
        }
    }



    render() {


        const { classes } = this.props;


        const customHeadClassesForCells = [0, 4, 5]


        const tableHead = [
            // { id: "0", name: "Product Code", sortItemCode: "productCode" },
            { id: "0", name: "Product Name", sortItemCode: "productName" },
            { id: "1", name: "Units", sortItemCode: "units" },
            { id: "2", name: "Packs", sortItemCode: "packs" },
            { id: "3", name: "Total Weight (Tonnes)", sortItemCode: "totalWeight" },
            { id: "4", name: "Pack Size", sortItemCode: "packSize" },
            { id: "5", name: "Weight (Tonnes)", sortItemCode: "weight" },
            { id: "6", name: "Quantity", sortItemCode: "quantity" },
            { id: "7", name: "Unit Rate", sortItemCode: "unitRate" },
            { id: "8", name: "Line Total", sortItemCode: "lineTotal" }
        ];

        // orderSummaryResult is guaranteed populated here - this page doesn't render until GetOrderSummary has run.
        const pricingByProductId = {};
        const orderSummaryResult = this.props.orderSummaryResult || {};
        (orderSummaryResult.orderItemsList || [])
            .concat(orderSummaryResult.deliveryItemsList || [])
            .forEach(item => {
                pricingByProductId[item.productId] = { unitPrice: item.unitPrice, lineTotal: item.lineTotal };
            });

        // unitRate/lineTotal live in the pricingByProductId lookup, not on the row - attach them here so the existing sort can read row[sortConfig.key].
        const productsWithPricing = (this.props.orderSelectedProductsList || []).map(row => {
            const pricing = pricingByProductId[row.productId];
            return {
                ...row,
                unitRate: pricing ? pricing.unitPrice : -1,
                lineTotal: pricing ? pricing.lineTotal : -1,
            };
        });


        const useSortableData = (items, config = null) => {
            const [sortConfig, setSortConfig] = React.useState(config);
            const [productList, setProductList] = React.useState(items);

            const sortedItems = React.useMemo(() => {
                let sortableItems = [...items];
                if (sortConfig !== null) {
                    sortableItems.sort((a, b) => {
                        if (a[sortConfig.key] < b[sortConfig.key]) {
                            return sortConfig.direction === 'ascending' ? -1 : 1;
                        }
                        if (a[sortConfig.key] > b[sortConfig.key]) {
                            return sortConfig.direction === 'ascending' ? 1 : -1;
                        }
                        return 0;
                    });
                }
                setProductList(sortableItems);
                return sortableItems;
            }, [items, sortConfig]);

            const requestSort = (key) => {
                let direction = 'ascending';
                if (
                    sortConfig &&
                    sortConfig.key === key &&
                    sortConfig.direction === 'ascending'
                ) {
                    direction = 'descending';
                }
                setSortConfig({ key, direction });
            };


            const requestChange = (key) => {

                let defaultTable = sortedItems.slice();
                let x = key.target;
                /*   console.log(x.value, rows);*/

                if (x.value == "")
                    setProductList(defaultTable);
                else {
                    const updatedList = defaultTable.filter(item => {
                        return (
                            item.productName.toLowerCase().search(x.value.replace(/[^\w\s]/gi, "").toLowerCase()) !== -1
                            //CHANGE DO WILDCARD SERACH ON THIS
                        );
                    });

                    let filterList = [...updatedList];
                    setProductList(filterList);
                }
            };

            return { items: productList, requestSort, sortConfig, requestChange };
        };



        const SelectProductsTable = (props) => {
            const { items, requestSort, sortConfig } = useSortableData(props.products);
            const filteredClaimsListData = items.slice();

            return (
                <div>
                    <h3 style={{ borderBottom: "2px dashed grey" }}>Selected Products</h3>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <div style={{ padding: "4px" }}>
                                <Paper sx={{ width: '100%', overflow: 'hidden', }}>
                                    <TableContainer style={{ maxHeight: 400, overflow: 'scroll' }}>

                                        <div className={classes.tableResponsive}>
                                            <Table stickyHeader className={classes.table}>
                                                <TableHead className={classes.tableHeadCell}>
                                                    <TableRow >
                                                        {tableHead.map((prop, key) => {
                                                            const tableCellClasses =
                                                                classes.tableHeadCell +
                                                                " " +
                                                                classes.tableCell +
                                                                " ";
                                                            return (
                                                                <TableCell className={tableCellClasses} key={key}>
                                                                    <TableSortLabel onClick={() => requestSort(prop.sortItemCode)}>
                                                                        {prop.name}
                                                                    </TableSortLabel>
                                                                </TableCell>
                                                            );
                                                        })}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {filteredClaimsListData.map((prop, key) => {
                                                        var rowColor = "";
                                                        var rowColored = false;
                                                        if (prop.color !== undefined) {
                                                            rowColor = prop.color;
                                                            rowColored = true;
                                                            prop = prop.data;
                                                        }
                                                        const tableRowClasses = classNames({
                                                            [classes.tableRowHover]: true,
                                                            [classes[rowColor + "Row"]]: '#00bcd4',
                                                            [classes.tableStripedRow]: true && key % 2 === 0,
                                                        });
                                                        return (
                                                            <TableRow key={key} hover={true} className={classes.tableRow + " " + tableRowClasses} >
                                                                {/* <TableCell className={classes.tableCell} >{prop.productCode}</TableCell> */}
                                                                <Tooltip title={
                                                                    <span>
                                                                     Product code: {prop.productCode} 
                                                                     <br />
                                                                     Product Group: {prop.productGroupName}
                                                                   </span>
                                                                 }>
                                                                    <TableCell className={classes.tableCell} >{prop.productName}</TableCell>
                                                                </Tooltip>
                                                                <TableCell className={classes.tableCell} >{prop.units}</TableCell>
                                                                <TableCell className={classes.tableCell} >{prop.packs}</TableCell>
                                                                <TableCell className={classes.tableCell} >{formatNumberWithDecimals(prop.totalWeight)}</TableCell>
                                                                <TableCell className={classes.tableCell}>{prop.packSize}</TableCell>
                                                                <TableCell className={classes.tableCell}>{formatNumberWithDecimals(prop.weight)}</TableCell>
                                                                <TableCell className={classes.tableCell}>{prop.quantity}</TableCell>
                                                                <TableCell className={classes.tableCell}>
                                                                    {pricingByProductId[prop.productId] ? formatCurrency(pricingByProductId[prop.productId].unitPrice) : "-"}
                                                                </TableCell>
                                                                <TableCell className={classes.tableCell}>
                                                                    {pricingByProductId[prop.productId] ? formatCurrency(pricingByProductId[prop.productId].lineTotal) : "-"}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow>

                                                    </TableRow>
                                                </TableFooter>
                                            </Table>

                                        </div>


                                    </TableContainer>
                                </Paper>
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
            )
        }


        return (

            <div>
                <SelectProductsTable
                    products={productsWithPricing}
                />
            </div>

        )





    }

}


const mapStateToProps = state => {
    return {
        user: state.userReducer.user,
        orderSelectedProductsList: state.orderReducer.orderSummaryProducts,
        orderSummaryResult: state.orderReducer.orderSummaryResult
    };
};



export default compose(withRouter, connect(mapStateToProps, null))(withStyles(useStyles)(OrderSelectedProductList));